import { jsx as _jsx } from "react/jsx-runtime";

function SvgAccount() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11zM12 5a4 4 0 100 8 4 4 0 000-8zm6.963 12.703A8.982 8.982 0 0112 21a8.982 8.982 0 01-6.963-3.297C6.307 15.147 9.331 14 12 14c2.67 0 5.693 1.147 6.963 3.703z"
    }, void 0)
  }), void 0);
}

export default SvgAccount;